// eslint-disable-file import/prefer-default-export
import moment from 'moment';
import groupBy from 'lodash/groupBy';
import values from 'lodash/values';
import { CHECKLIST_FILTERS } from './constants';

export const isSponsoredLink = (url = '') => {
  if (typeof url !== 'string') return false;

  const hasHttp = /(https|http):\/\/.+/g;
  const hasZolaDomain = /zola\.com.+/g;

  return hasHttp.test(url) && !hasZolaDomain.test(url);
};

export const getTaskGroup = (dueAt, now) => {
  const nowMoment = moment(now);
  const dueAtMonth = parseInt(moment(dueAt).format('M'), 10);
  const pastDue = dueAtMonth <= nowMoment.month();

  if (pastDue) {
    return `This Month (${nowMoment.format('MMMM YYYY')})`;
  }

  return moment(dueAt).format('MMMM YYYY');
};

export const getDaysTillWeddingDate = (now, date) => {
  if (!now || !date) return 0;

  const weddingDate = moment(date);
  return weddingDate.diff(now, 'days');
};

export const getChecklistFiltersOptions = () => values(CHECKLIST_FILTERS);
export const getChecklistFiltersGrouped = () => groupBy(CHECKLIST_FILTERS, filter => filter.filterGroup);
export const getChecklistFilterLabel = filterKey => CHECKLIST_FILTERS[filterKey].label;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/helpers.js